import React from 'react';
import { View, Text, StyleSheet } from '@react-pdf/renderer';
import { useTemplateColors } from 'PDF/TemplateEngine/TemplateColorsContext';

function EmptyState({ title, subtitle }) {
  const { colors, FONT } = useTemplateColors();
  const styles = StyleSheet.create({
    box: {
      border: `1px dashed ${colors.borderStrong || colors.border}`,
      borderRadius: 8,
      backgroundColor: colors.lightBg,
      padding: '0.35cm',
      flexDirection: 'column',
      gap: '0.05cm',
    },
    title: { fontSize: 10, fontFamily: FONT.bold, color: colors.text || colors.darkText },
    sub: { fontSize: 9, fontFamily: FONT.base, color: colors.muted },
  });
  return (
    <View style={styles.box}>
      <Text style={styles.title}>{title}</Text>
      {subtitle ? <Text style={styles.sub}>{subtitle}</Text> : null}
    </View>
  );
}

export default EmptyState;
